/* Kindly nav: desktop mega menu (snippets/kindly-mega.liquid) + mobile drawer (snippets/kindly-drawer.liquid).
   Mega: click/tap toggles, hover opens after 120 ms on fine pointers, closes 250 ms after the pointer leaves,
   Esc closes and returns focus, click outside closes, one panel open at a time.
   Drawer: <kindly-drawer> opens a modal panel, locks page scroll, traps Tab, Esc / overlay / X close it. */
(function () {
  var nav = document.querySelector('[data-kn]');
  if (nav && !nav.__kn) {
    nav.__kn = true;
    var triggers = Array.prototype.slice.call(nav.querySelectorAll('[data-kn-trigger]'));
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var openT, closeT;
    var panelOf = function (t) { return document.getElementById(t.getAttribute('aria-controls')); };
    var closeAll = function (except) {
      triggers.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var p = panelOf(t); if (p) p.hidden = true;
      });
      document.documentElement.classList.toggle('kn-open', !!except);
    };
    var open = function (t) {
      closeAll(t);
      t.setAttribute('aria-expanded', 'true');
      var p = panelOf(t); if (p) p.hidden = false;
      document.documentElement.classList.add('kn-open');
    };
    triggers.forEach(function (t) {
      var li = t.parentNode;
      t.addEventListener('click', function () {
        clearTimeout(openT); clearTimeout(closeT);
        /* A mouse that hovered first already opened the panel: a click then keeps it open instead of toggling it shut. */
        var hoverOpened = t.__hoverAt && Date.now() - t.__hoverAt < 1500;
        if (t.getAttribute('aria-expanded') === 'true' && !hoverOpened) closeAll(); else open(t);
        t.__hoverAt = 0;
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(t); var a = panelOf(t) && panelOf(t).querySelector('a'); if (a) a.focus(); }
      });
      if (fine) {
        li.addEventListener('mouseenter', function () { clearTimeout(closeT); clearTimeout(openT); openT = setTimeout(function () { if (t.getAttribute('aria-expanded') !== 'true') { open(t); t.__hoverAt = Date.now(); } }, 120); });
        li.addEventListener('mouseleave', function () { clearTimeout(openT); t.__hoverAt = 0; closeT = setTimeout(function () { if (t.getAttribute('aria-expanded') === 'true') closeAll(); }, 250); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var t = triggers.filter(function (x) { return x.getAttribute('aria-expanded') === 'true'; })[0];
      if (t) { closeAll(); t.focus(); }
    });
    document.addEventListener('click', function (e) { if (!nav.contains(e.target)) closeAll(); });
    nav.addEventListener('focusout', function (e) { if (e.relatedTarget && !nav.contains(e.relatedTarget)) closeAll(); });
  }

  if (!window.customElements || customElements.get('kindly-drawer')) return;
  customElements.define('kindly-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.__kd) return; this.__kd = true;
      this.btn = this.querySelector('[data-kd-open]');
      this.panel = this.querySelector('[data-kd-panel]');
      this.overlay = this.querySelector('.kd__overlay');
      this.btn.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-kd-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      /* Portal to <body>: the sticky header is its own stacking context, page sticky bars must not cover the drawer.
         A re-rendered header (theme editor) replaces any earlier moved copy. */
      document.querySelectorAll('body > #KindlyDrawer, body > .kd__overlay').forEach((n) => { if (n !== this.panel && n !== this.overlay) n.remove(); });
      document.body.appendChild(this.overlay); document.body.appendChild(this.panel);
      this.panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(this.panel.querySelectorAll('a[href],button,input,summary'), (x) => x.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', (m) => { if (m.matches) this.close(true); });
    }
    disconnectedCallback() {
      if (this.panel && this.panel.parentNode === document.body) this.panel.remove();
      if (this.overlay && this.overlay.parentNode === document.body) this.overlay.remove();
      document.documentElement.classList.remove('kd-lock');
    }
    open() {
      this.panel.hidden = false; this.overlay.hidden = false;
      this.btn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('kd-lock');
      requestAnimationFrame(() => requestAnimationFrame(() => { this.panel.classList.add('is-open'); var c = this.panel.querySelector('.kd__close'); if (c) c.focus(); }));
    }
    close(silent) {
      this.panel.classList.remove('is-open');
      this.btn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('kd-lock');
      this.panel.hidden = true; this.overlay.hidden = true;
      if (!silent) this.btn.focus();
    }
  });
})();
